import { z } from 'zod';

import { missionHistorySchema, missionPatchSchema, missionSchema } from '../schema/Mission.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import {
  getMissionHistoryUrl,
  getMissionsDetailUrl,
  getMissionsUrl,
  patchMissionsUrl,
} from './constants.ts';

export async function getMissions(
  territorySlug: string,
  queryParameters: Record<string, string>,
  signal?: AbortSignal,
) {
  const { data } = await api.get(getMissionsUrl(territorySlug, queryParameters), { signal });
  return validateData(z.array(missionSchema), data['results'], 'Missions');
}

export async function getMissionsDetail(territorySlug: string, missionId: string, signal?: AbortSignal) {
  const { data } = await api.get(getMissionsDetailUrl(territorySlug, missionId), { signal });
  return validateData(missionSchema, data, 'Mission');
}

export async function getMissionHistory(territorySlug: string, missionId: string, signal?: AbortSignal) {
  const { data } = await api.get(getMissionHistoryUrl(territorySlug, missionId), { signal });
  return validateData(missionHistorySchema, data, 'Mission History');
}

export async function patchMissions(territorySlug: string, missionId: number, payload: object) {
  const validatedData = validateData(missionPatchSchema, payload, 'Update Mission');
  return await api.patch(patchMissionsUrl(territorySlug, missionId), validatedData);
}
